import {Link, useParams} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi, setTitle, consoleLog} from '../../utils/functions';
import {UserContext, TestService} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
//import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Blocks from '../components/bbcode/blocks';
import '../components/fontawesome/fontawesome';
import { createReactEditorJS } from 'react-editor-js';
//import Raw from '@editorjs/raw';
import TimezoneSelect, { allTimezones } from 'react-timezone-select';
import UploadFile from '../components/upload/upload';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import './css/overview.css';
//import './css/header.css';

const ReactEditorJS = createReactEditorJS();

class PortalAdminOverview extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			service: {
				status: false,
				id: this.props.service,
				name: '',
			},

			overview: {
				followers: [],
			},

			/*description: {},
			overview: {},
			followers: [],
			edit: false,
			description_temp: null,
			timezone: null,
			discord: {
				enabled: false,
				visible: false,
			},*/
		};
		this.editorInstance = React.createRef();
		this.getDescription = this.getDescription.bind(this);
		this.setDescription = this.setDescription.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleTimezone = this.handleTimezone.bind(this);
		this.changeAvatar = this.changeAvatar.bind(this);
		this.setDiscord = this.setDiscord.bind(this);
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( getUser );
		await value.setWorker( this.props.service );
		EventEmitter.emit('/client', {data: 'no value'});

		
		//this.setState({status: true, services: x.data.Services});

		/*
		let params = new URLSearchParams();
		const x = await postApi('/v3/index', params);
		//this.setState({clubbers: x.data.Clubbers, radio: x.data.Radio, next: x.data.Next, posters: x.data.WeeklyDJs, sets: x.data.Sets, status: true, affliiate: x.data.Affiliate});

		const IndexSchedule = EventEmitter.addListener('/index/schedule', async data => {
			this.setState({next: data.Next, live: data.Live});
		}); this.setState({IndexSchedule});
		*/

		await this.getDescription();
	}

	componentWillUnmount() {
	}


	async getDescription() {
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		const x = await postApi(`${this.context.worker[this.props.service]}/v3/admin/admin`, params);
		consoleLog(x.data);

		let service = this.state.service;
		service.status = true;
		service.name = x.data.servicename;
		//console.log(x.data);

		this.setState({service, overview: x.data});
		setTitle('Admin', x.data.title);
	}


	async setDescription() {
		let edit = !this.state.edit;
		let description_temp = null;
		if( edit ) {
			description_temp = this.state.description;
		}
		await this.getDescription();
		this.setState({edit, description_temp});
	}


	async handleChange(event) {
		let description_temp = this.state.description_temp;
		let item = event.target.value;
		if( event.target.name === "title" ) description_temp.title = item;
		if( event.target.name === "description" ) description_temp.description = item;
		this.setState({description_temp});
	}

	handleTimezone(timezone) {
		this.setState({timezone: timezone.value});
	}
	
	async submitChange() {

		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		params.append('title', this.state.description_temp.title);

		const outputData = await this.editorInstance.current.save();
		params.append('description', JSON.stringify(outputData.blocks));
    params.append('avatar', this.state.description_temp.avatar);
		params.append('cover', this.state.description_temp.cover);
		params.append('timezone', this.state.timezone);

		await putApi(`${this.context.worker[this.props.service]}/v3/admin/admin`, params);

		await this.setDescription();

	}

	async changeAvatar(name) {
		let description_temp = this.state.description_temp;
		description_temp.avatar = name;
		this.setState({description_temp});
	}

	setDiscord() {
		let discord = this.state.discord;
		discord.visible = !discord.visible;
		this.setState({discord});
	}

	render() {
		const user = this.context;

		const followers = this.state.overview.followers.map((e, i) => {
			return (
				<Col key={i}>
					<div className="card custom-card">
						<div className="card-body">
							<div className="d-flex align-items-center">
								<div className="me-2">
									<div className="avatar avatar-md bg-success-transparent">
										<img src={`https://cloud.ultrastream.io/images/platforms/${e.platform.toLowerCase()}.png`} alt="Platform Avatar" />
									</div>
								</div>
								<div className="flex-1">
									<a aria-label="anchor" href="javascript:void(0)" className="tx-inverse float-end text-muted" data-bs-toggle="dropdown" aria-expanded="false"><i className="bi bi-three-dots tx-14"></i></a>
									<ul className="dropdown-menu">
										<li><a href="javascript:void(0)" className="dropdown-item border-bottom">Action</a></li>
										<li><a href="javascript:void(0)" className="dropdown-item border-bottom">Another Action</a></li>
										<li><a href="javascript:void(0)" className="dropdown-item">Something Else Here</a></li>
									</ul>
									<div className="mg-b-6">
										<p className="mb-0 tx-13 text-muted">{e.username} Followers</p>
									</div>
									<div className="flex-between">
										{/*<h3 className="tx-20 mb-0 font-weight-normal">{e.followers} here</h3>*/}

										<p className="text-lg fw-semibold mb-1">{e.followers}
											{e.month &&
												<OverlayTrigger
													placement="top"
													delay={{ show: 250, hide: 400 }}
													overlay={<Tooltip id="button-tooltip">
														{e.month[1]>0?'Gained':'Lost'} {Math.abs(e.month[1])} followers in the last month
													</Tooltip>}
												>
													<span>
													{e.month && e.month[0] > 0 &&
														<span className="text-success fs-12 ms-2">
															<FontAwesomeIcon icon="arrow-trend-up" className="me-2 fs-12" />
															{Math.abs(e.month[0])}%
														</span>
													}
													{e.month && e.month[0] < 0 &&
														<span className="text-danger fs-12 ms-2">
															<FontAwesomeIcon icon="arrow-trend-down" className="me-2 fs-12" />
															{Math.abs(e.month[0])}%
														</span>
													}
													</span>
												</OverlayTrigger>
											}
											
										</p>

									</div>
									<div>
										{e?.twitch_bits > 0 &&
											<>Bits {e.twitch_bits}, </>
										}
										{e?.twitch_subscribe > 0 &&
											<>Subscribers {e.twitch_subscribe}, </>
										}
										{e?.twitch_trains > 0 &&
											<>Trains {e.twitch_trains}, </>
										}
									</div>
								</div>
							</div>
						</div>
					</div>
				</Col>
			)
		});

		return (
			<>

				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Dashboard</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								<li className="breadcrumb-item"><Link to={`/${this.state.service.id}`}>{this.state.service.name}</Link></li>
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>

				{this.state.service.status === true &&
					<div className="main-content app-content">
						<div className="container-fluid">
							<Row>
									
								<Col xs={12}>
									{this.state.overview.followers.length > 0 ?
                 	 <Row>{followers}</Row>
                	:
										<div className="card custom-card">
											<div className="card-header p-0">
												<div className="d-flex p-3 ">
													<div className="">
														<svg className="me-4  bg-success-transparent  alt-notify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#75cfa5" d="m20.34 9.32-13.99-7a3 3 0 0 0-4.08 3.9L4.41 11l.26.59a1.06 1.06 0 0 1 0 .82l-.26.59-2.14 4.78a2.954 2.954 0 0 0 .67 3.38A2.966 2.966 0 0 0 5 22a3.141 3.141 0 0 0 1.35-.32l13.99-7a2.993 2.993 0 0 0 0-5.36Z"></path><path fill="#198754" d="M14.46 12a.997.997 0 0 1-1 1H4.41l.26-.59a1.06 1.06 0 0 0 0-.82L4.41 11h9.05a.997.997 0 0 1 1 1Z"></path></svg>
													</div>
													<div className="mt-0 text-start">
														<span className="fs-14 fw-semibold">Admin Overview</span>
														<p className="fs-13 text-muted mb-0">Details about your {this.state.overview?.overview?.title}</p>
													</div>
												</div>
											</div>
											{/*<div className="card-body ">
												
											</div>*/}
											<TestService service={this.state.service.id} worker={user.worker[this.state.service.id]} />
										</div>
									}
                </Col>
							</Row>
							
							{/*<Row>
								<Col xs={12}>
									<div className="card custom-card custom-frame">
                    <div className="card-header justify-content-between">
                      <div className="card-title">
												{this.state.overview.title}
                      </div>
                    </div>
                    <div className="card-body">
											<Row>
												<Col>
													Invites: {this.state.overview.invites === true?'Open':'Closed'}<br />
													Members: {this.state.overview.overview.membersMax}<br />
													Admins: {this.state.overview.overview.adminsMax}<br />
													<Button size="sm" onClick={this.setDiscord}>Enable Discord</Button>
													
													{/*Ower: <Link to={`/${this.state.overview.owner.username}`}>{this.state.overview.owner.title}</Link><br />
													Admins: {this.state.overview.adminsMax}*}
													{/*(() => {
														const y = this.state.overview.admins.map((g,k) => {
															return(
																<React.Fragment key={k}>&nbsp;- {g.title}</React.Fragment>
															)
														});
															return y;
														})()*}
													<br />
												</Col>
											</Row>
											
										</div>
									</div>
								</Col>
									
							</Row>*/}

							<Row>
								<Col xs={12}>
									<div className="card custom-card custom-frame">
										<div className="card-header justify-content-between">
											<div className="card-title">
												Your radio station details:
											</div>
											<div className="dropdown d-flex">
												<Link to={`/${this.state.service.id}/details`}><Button size="sm" variant="success">Edit Details</Button></Link>
											</div>
										</div>
										<div className="card-body">

											<Row>
												<Col>
													<div className="form-group row pt-1 pb-0 mb-1">
														<div className="d-flex">
															<label className="col-sm-4 col-form-label col-form-label-sm ps-2">
																<strong>Radio Station Logo</strong>
															</label>
														
															<div className="col-md-6 avatar avatar-xxl">
																<img src={`https://cloud.ultrastream.io/images/${this.state.overview.avatar}`} alt='avatar' />
															</div>
														</div>
													</div>
													<div className="form-group row pt-1 pb-0 mb-1">
														<label htmlFor="title" className="col-sm-4 col-form-label col-form-label-sm ps-4">
															<strong>Radio Station Name</strong>
														</label>
														<div className="col-md-6">
															<h4><small>{this.state.overview.title}</small></h4>
														</div>
													</div>
													{/*<div className="form-group row pt-1 pb-0 mb-1">
														<label className="col-sm-4 col-form-label col-form-label-sm ps-4">
															<strong>Radio Station Logo</strong>
														</label>
														<div className="col-md-6 mt-2">
															{/*<Form.Control type="text" name="title" id="title" value={this.state.description_temp.title} onChange={this.handleChange} className="form-control-sm" placeholder="title" />*}
														</div>
													</div>*/}
													<div className="form-group row pt-1 pb-0 mb-1">
														<label htmlFor="description" className="col-sm-4 col-form-label col-form-label-sm ps-4">
															<strong>Radio Station Description</strong>
														</label>
														<div className="col-md-6">
															{/*<Form.Control type="text" name="description" id="description" value={this.state.description_temp.description} onChange={this.handleChange} className="form-control-sm" placeholder="title" />*/}
															<div className="form-control form-control-sm">
															<Blocks blocks={this.state.overview.description} />
															</div>
														</div>
													</div>
													<div className="form-group row pt-1 pb-0 mb-1">
														<label htmlFor="timezone" className="col-sm-4 col-form-label col-form-label-sm ps-4">
															<strong>Radio Station Timezone</strong>
														</label>
														<div className="col-md-6 mt-2">
															{this.state.timezone}
														</div>
													</div>
												</Col>
											</Row>
										</div>
									</div>
								</Col>
									
							</Row>

							<Row>
								<Col xs={12}>
									<div className="card custom-card custom-frame">
                    <div className="card-header justify-content-between">
                      <div className="card-title">
												Inactive DJ Members
                      </div>
											
                    </div>
                    <div className="card-body">
											<Row>
												<Col>
													DJ's that have not yet played or played within 90 days
													
												</Col>
											</Row>
											
										</div>
									</div>
								</Col>
									
							</Row>
							
						</div>
					</div>
				}
				{/*<Modal
					show={this.state.discord.visible}
					size="lg"
					onHide={this.setDiscord}
					centered
				>
					<Modal.Header closeButton>
						<Modal.Title id="contained-modal-title-vcenter">
							Enable Discord
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<h5>Add Discord Ultrastream Bot</h5>
						<p>
							Cras mattis consectetur purus sit amet fermentum. Cras justo odio,
							dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac
							consectetur ac, vestibulum at eros.
						</p>
					</Modal.Body>
					<Modal.Footer>
						<Button size="sm" onClick={this.setDiscord}>Close</Button>
					</Modal.Footer>
				</Modal>*/}
			</>
		);
	}
}

const Admin = props => {
  const { service } = useParams();
  return <PortalAdminOverview service={service} {...props} />
}
export default Admin;